import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface CustomerRequest {
    union_option: boolean;
    default_sender: string;
    union_sender: string;
}

export const usePostCustomerSender = (
    successCallback?: () => void,
    customerId?: number,
): UseMutationResult<null, Error, CustomerRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, CustomerRequest>({
        mutationFn: async (customerSenderData: CustomerRequest) => {
            const response = await axios.post(
                enum_api_uri.post_customer_sender.replace(":customer_idx", customerId?.toString() || ""),
                customerSenderData,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerSender"] });
            successCallback?.();
        },
    });
};
